/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getProject } from '../../Redux/ProjectSlice';
import ReactSelect from '../Common/ReactSelect';
import { Phase } from '../Common/Common';
import 'react-calendar/dist/Calendar.css';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { getAllLoginUser, handleAddTaks } from '../../Redux/TaskSlice';
import { AddRowBtn, DeleteBtn } from '../Common/Buttons';

export default function AddTasks({ toggle, setloadFrist, EditTask, TemplateID, AddTemplates, MovePhase, PhaseName, identityName }) {
    const { register, handleSubmit, setValue, } = useForm();
    const storeProject = useSelector((state) => state.root.Project)
    const { User } = useSelector((state) => state.root.Tasks)

    const dispatch = useDispatch()

    const [Day, setDay] = useState(0);
    const [selectedProject, setselectedProject] = useState(null);
    const [selectedPhase, setselectedPhase] = useState({ value: 0, label: `${PhaseName ? PhaseName : 'Phase unassigned'}`, });
    const [selecteddate, setselecteddate] = useState(moment().format("YYYY-MM-DD"));
    const [loadFist, setLoadFist] = useState(true);
    const [subTask, setsubTask] = useState([{ task: '', date: moment().format("YYYY-MM-DD"), day: '' }]);
    const [Error, setError] = useState('');
    const [markAsDone, setmarkAsDone] = useState(false);
    const [userAccess, setuserAccess] = useState(null);

    useEffect(() => {
        if (loadFist) {
            dispatch(getProject({}));
            dispatch(getAllLoginUser({}));
            // fetchUserData()
            setLoadFist(false);
        }
    }, [storeProject, loadFist]);

    useEffect(() => {
        if (EditTask) {
            const updatedSubTask = EditTask?.subTaskDetails && EditTask?.subTaskDetails.map((x) => ({ task: x.subTaskName, date: moment(x?.dueDate).format("YYYY-MM-DD"), day: x?.day }))
            if (EditTask?.subTaskDetails && EditTask?.subTaskDetails) {
                setsubTask(updatedSubTask)
            }
            setValue("Description", EditTask?.description)
            if (EditTask && EditTask?.projectID) { setselectedProject({ label: EditTask?.projectName, value: EditTask?.projectID }); }
            if (EditTask && EditTask?.assigneeID) { setuserAccess({ label: EditTask?.assigneeName, value: EditTask?.assigneeID }); }
            if (EditTask && EditTask?.phase) { setselectedPhase({ label: EditTask?.phase, value: EditTask?.phase }); }
            if (EditTask && EditTask?.dueDate) { setselecteddate(moment(EditTask?.dueDate).format("YYYY-MM-DD")); }
            if (EditTask && EditTask?.day) { setDay(EditTask?.day) }
            setmarkAsDone(EditTask?.markAsDone ? EditTask?.markAsDone : markAsDone)
        }
    }, [EditTask,]);

    const handletask = (e, index) => {
        const { value } = e.target;
        const updatedSubTask = [...subTask];
        updatedSubTask[index].task = value;
        setsubTask(updatedSubTask);
    };

    const handleTaskDate = (e, index) => {
        const { value } = e.target;
        const updatedSubTask = [...subTask];
        updatedSubTask[index].date = value;
        setsubTask(updatedSubTask);
    };

    const handleTaskDay = (e, index) => {
        const { value } = e.target;
        const updatedSubTask = [...subTask];
        updatedSubTask[index].day = value;
        setsubTask(updatedSubTask);
    };


    const onSubmit = async (data) => {
        try {
            if (!TemplateID && !selectedProject) {
                return setError('Project is required');
            }
            const Payload = {
                taskID: EditTask?.taskID ? EditTask.taskID : 0,
                taskName: 'Task',
                phase: selectedPhase?.label,
                assigneeID: userAccess?.value,
                dueDate: selecteddate,
                projectID: selectedProject?.value,
                description: data.Description,
                markAsDone: markAsDone,
                // markAsDone: EditTask?.markAsDone !== undefined ? EditTask.markAsDone : true,
                userID: 1,
                day: Day,
                identityName: "Task",
                type: TemplateID ? "ProjectTemplate" : "Task",
                subTaskDetails: subTask.map((item) => ({
                    subTaskID: 0,
                    taskID: 0,
                    day: item?.day,
                    subTaskName: item.task,
                    dueDate: item.date,
                    markAsDone: markAsDone ? markAsDone : false,
                })),
            };

            const res = await dispatch(handleAddTaks(Payload));
            const taskData = res?.payload?.data

            if (TemplateID && !EditTask?.phaseId) {
                AddTemplates(taskData)
            } else if (EditTask?.phaseId) {
                MovePhase(taskData, EditTask?.TaskStatus)
            }

            if (res.payload.status === true) {
                setloadFrist(true);
                setError('');
                toggle();
                setsubTask([{ task: '', date: moment().format('YYYY-MM-DD'), day: "" }]);
            }
        } catch (error) {
            console.log('error :>> ', error);
        }
    };

    const modalTitle = `${EditTask && EditTask?.taskID ? 'Update' : 'Add'} Task`;
    const inputClass = "lead-modal-input";
    const labelClass = "lead-modal-label";
    const fieldClass = "lead-modal-field";
    const errorClass = "lead-modal-error";

    return (
        <>
            <div
                id="default-modal"
                tabIndex="-1"
                aria-hidden="true"
                className="lead-modal-backdrop"

            >
                <div className="lead-modal-shell">
                    <div className="lead-modal-card">
                        <div className="lead-modal-header">
                            <h3 className="lead-modal-title">{modalTitle}</h3>
                            <AiOutlineCloseCircle
                                className="lead-modal-close"
                                onClick={toggle}
                            />
                        </div>
                        <>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="lead-modal-body">
                                    <div className="lead-modal-grid vertical-scroll-inner">
                                        <div className="lead-modal-section">
                                            <div className="lead-modal-section-header">
                                                <span className="lead-modal-section-dot" />
                                                <h4>Task details</h4>
                                            </div>
                                            <div className="lead-modal-section-content">
                                                <div className={fieldClass}>
                                                    <label className={labelClass}>Assignee (optional)</label>
                                                    <ReactSelect
                                                        id="Project"
                                                        name="Project"
                                                        selectedValue={userAccess}
                                                        options={
                                                            User &&
                                                                User?.length > 0
                                                                ? User.map((item) => ({
                                                                    label: item?.userName,
                                                                    value: item?.userID,
                                                                }))
                                                                : [{ value: "", label: "Not Found" }]
                                                        }
                                                        handleSelectChange={(option) => {
                                                            setuserAccess(option)
                                                        }}
                                                    />
                                                </div>
                                                <div className={fieldClass}>
                                                    <label htmlFor="expectedCloseDate" className={labelClass}>Due date</label>
                                                    {
                                                        TemplateID ? (
                                                            <div className='task-modal-day-row'>
                                                                <input
                                                                    type="number"
                                                                    min="0"
                                                                    className={inputClass}
                                                                    value={Day}
                                                                    onChange={(e) => {
                                                                        let inputValue = e.target.value.replace(/\D/g, '');
                                                                        if (inputValue.length > 4) {
                                                                            inputValue = inputValue.slice(0, 4);
                                                                        }
                                                                        setDay(inputValue);
                                                                    }}
                                                                />

                                                                <span className="task-modal-help-text">days from <strong>project start date</strong></span>
                                                            </div>
                                                        ) : (
                                                            <input
                                                                type='date'
                                                                datepicker
                                                                value={selecteddate}
                                                                className={inputClass}
                                                                onChange={(e) => {
                                                                    setselecteddate(e.target.value);
                                                                }}
                                                            />
                                                        )
                                                    }
                                                </div>
                                                {!TemplateID && (
                                                    <div className={fieldClass}>
                                                        <label className={labelClass}>Project</label>
                                                        <ReactSelect
                                                            id="Project"
                                                            name="Project"
                                                            selectedValue={selectedProject}
                                                            options={
                                                                storeProject &&
                                                                    storeProject?.getProject?.length > 0
                                                                    ? storeProject.getProject.map((item) => ({
                                                                        label: item?.title,
                                                                        value: item?.projectID,
                                                                    }))
                                                                    : [{ value: "", label: "Not Found" }]
                                                            }
                                                            handleSelectChange={(option) => {
                                                                setselectedProject(option)
                                                            }}
                                                        />
                                                        {selectedProject && selectedProject?.label?.length > 0 ? "" : Error && (
                                                            <div className={errorClass}>{Error}</div>
                                                        )}
                                                    </div>
                                                )}

                                                <div className={fieldClass}>
                                                    <label className={labelClass}>Phase</label>
                                                    <ReactSelect
                                                        selectedValue={selectedPhase}
                                                        options={
                                                            Phase &&
                                                                Phase?.length > 0
                                                                ? Phase.map((item) => ({
                                                                    value: item?.id ?? "",
                                                                    label: item?.name,
                                                                }))
                                                                : [{ value: "", label: "Not Found" }]
                                                        }
                                                        handleSelectChange={(option) => setselectedPhase(option)}
                                                    />
                                                </div>

                                                <div className={fieldClass}>
                                                    <label className={labelClass}>Group</label>
                                                    <ReactSelect />
                                                </div>

                                                <div className={fieldClass}>
                                                    <label htmlFor="task-description" className={labelClass}>Description</label>
                                                    <textarea type="text"
                                                        id="task-description"
                                                        name="name"
                                                        {...register("Description",)}
                                                        className="lead-modal-input task-modal-textarea"
                                                    />

                                                </div>
                                            </div>
                                        </div>

                                        <div className="lead-modal-section">
                                            <div className="lead-modal-section-header">
                                                <span className="lead-modal-section-dot lead-modal-section-dot-blue" />
                                                <h4>Subtasks</h4>
                                            </div>
                                            <div className="lead-modal-section-content">
                                                <div className={fieldClass}>
                                                    <label className={labelClass}>Task</label>
                                                    <div className="lead-modal-stack">
                                                        {subTask?.length > 0 ? (
                                                            subTask.map((item, index) => (
                                                                <div key={index} className="task-modal-subtask-row">
                                                                    <input
                                                                        type="text"
                                                                        id={`task_${index}`}
                                                                        name={`task${index}`}
                                                                        placeholder="Enter Task"
                                                                        className={inputClass}
                                                                        value={item?.task}
                                                                        onChange={(e) => handletask(e, index)}
                                                                    />
                                                                    {!identityName ? (
                                                                        <input
                                                                            type="number"
                                                                            min="0"
                                                                            placeholder="set due date"
                                                                            className={inputClass}
                                                                            value={item?.day}
                                                                            onChange={(e) => {
                                                                                let inputValue = e.target.value.replace(/\D/g, '');
                                                                                if (inputValue.length > 4) {
                                                                                    inputValue = inputValue.slice(0, 4);
                                                                                }
                                                                                handleTaskDay({ ...e, target: { ...e.target, value: inputValue } }, index);
                                                                            }}
                                                                        />
                                                                    ) : identityName === 'Project' ? (
                                                                        <input
                                                                            type="date"
                                                                            className={inputClass}
                                                                            value={item.date}
                                                                            onChange={(e) => handleTaskDate(e, index)}
                                                                        />
                                                                    ) : null}
                                                                    {subTask.length > 1 && (
                                                                        <DeleteBtn
                                                                            onClick={() => setsubTask((prev) => prev.filter((_, i) => i !== index))}
                                                                        />
                                                                    )}
                                                                    {index === subTask.length - 1 && (
                                                                        <AddRowBtn
                                                                            label="Subtask"
                                                                            onClick={() => setsubTask((prev) => [
                                                                                ...prev,
                                                                                { task: '', date: moment().format('YYYY-MM-DD'), day: '' },
                                                                            ])}
                                                                        />
                                                                    )}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="task-modal-subtask-row task-modal-subtask-row-empty">
                                                                <AddRowBtn
                                                                    label="Subtask"
                                                                    onClick={() => setsubTask([{ task: '', date: moment().format('YYYY-MM-DD'), day: '' }])}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="lead-modal-footer">
                                    <button
                                        type="button"
                                        onClick={toggle}
                                        className="px-4 py-2 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 text-sm font-semibold rounded-lg transition-colors cursor-pointer mr-2">
                                        Close
                                    </button>

                                    <div className="task-modal-footer-actions">
                                        <input
                                            type="checkbox"
                                            id="markAsDone"
                                            className="task-modal-checkbox"
                                            checked={markAsDone}
                                            onChange={(e) => {
                                                setmarkAsDone(e.target.checked);
                                            }}
                                        />
                                        <label htmlFor='markAsDone' className="task-modal-checkbox-label">
                                            Mark as done
                                        </label>
                                        <button type="submit" className="px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 cursor-pointer">{EditTask?.taskID ? 'Update' : "Save"} </button>
                                    </div>
                                </div>
                            </form>
                        </>
                    </div>
                </div >
            </div >
        </>
    )
}
